export const GET_VISITS = 'GET_VISITS';
export const GET_VISITS_SUCCESS = 'GET_VISITS_SUCCESS';
export const GET_VISITS_FAIL = 'GET_VISITS_FAIL';
// clinic name 
export const GET_CLINIC_NAME = 'GET_CLINIC_NAME';
export const GET_CLINIC_NAME_SUCCESS = 'GET_CLINIC_NAME_SUCCESS';
export const GET_CLINIC_NAME_FAIL = 'GET_CLINIC_NAME_FAIL';
